/* Ironfang slab turntable — ported from turntable-reference.html.
   4 cross-faded frames simulate a 360deg rotation. Autoplay + drag-to-rotate,
   autoplay resumes 2s after the last drag. Supports multiple instances per page. */
(function () {
  var DRAG_SENS = 0.45; // degrees per pixel dragged
  var IDLE_MS = 2000; // autoplay resumes this long after last drag
  var DISSOLVE_FRACTION = 0.06; // portion of each 90deg segment spent dissolving into the next frame; rest holds solid
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initTurntable(stage) {
    var frames = stage.querySelectorAll('.ift-frame');
    if (!frames.length) return;

    var speed = parseFloat(stage.getAttribute('data-turn-speed')) || 36;
    var autoplay = stage.getAttribute('data-autoplay') === 'true';
    var angle = 0;
    var dragging = false;
    var lastX = 0;
    var idleUntil = 0;
    var last = 0;
    var raf;

    function onPointerDown(e) {
      dragging = true;
      lastX = e.clientX;
      idleUntil = performance.now() + IDLE_MS;
      stage.style.cursor = 'grabbing';
    }
    function onPointerMove(e) {
      if (!dragging) return;
      angle += (e.clientX - lastX) * DRAG_SENS;
      lastX = e.clientX;
      idleUntil = performance.now() + IDLE_MS;
    }
    function onPointerUp() {
      dragging = false;
      stage.style.cursor = 'grab';
    }

    stage.addEventListener('pointerdown', onPointerDown);
    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', onPointerUp);

    function tick(t) {
      raf = requestAnimationFrame(tick);
      if (!last) last = t;
      var dt = Math.min((t - last) / 1000, 0.05);
      last = t;
      if (autoplay && !reduceMotion && !dragging && t > idleUntil) {
        angle += speed * dt;
      }
      var a = ((angle % 360) + 360) % 360;
      var segment = Math.floor(a / 90) % frames.length;
      var next = (segment + 1) % frames.length;
      var segT = (a % 90) / 90; // 0..1 progress through this segment
      var holdEnd = 1 - DISSOLVE_FRACTION;
      var nextOpacity = segT <= holdEnd ? 0 : (segT - holdEnd) / DISSOLVE_FRACTION;
      var curOpacity = 1 - nextOpacity;
      for (var i = 0; i < frames.length; i++) {
        var opacity = 0;
        if (i === segment) opacity = curOpacity;
        else if (i === next) opacity = nextOpacity;
        frames[i].style.opacity = opacity.toFixed(3);
      }
    }
    raf = requestAnimationFrame(tick);
  }

  function init() {
    var stages = document.querySelectorAll('.ift-stage[data-turntable]');
    for (var i = 0; i < stages.length; i++) initTurntable(stages[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
